export const EMAIL_FMT_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_DISPLAY_NAME_LENGTH = 30;

export const HAPPENINGS_SUPPORT_EMAIL = 'hello@whatshappenings.com';